















































import Vue from "vue";

import AudioElement from "@tt-app/components/exercise/common/AudioElement.vue";
import ExerciseHtmlText from "@tt-app/components/exercise/consolidated/exercise/body/ExerciseHtmlText.vue";
import Separator from "@tt-app/components/ui/Separator.vue";
import { concatenatedStringArray } from "@tt-app/utils";

import IconIncorrect from "@joyz/app-core/assets/icons/Incorrect.svg";
import IconCorrect from "@joyz/app-core/assets/icons/Correct.svg";
import IconSkipped from "@joyz/app-core/assets/icons/misc/DrillSkip.svg";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";

interface Icons {
  [key: string]: string | Icons;
}

interface Data {
  icons: Icons;
}

interface Methods {
  concatenatedBody: (body: string | string[]) => string;
}

interface Computed {
  accuracyIcon: any;
  answerExplanation: any;
  correctAnswer: string;
  correctAnswerTranslation: string;
  explanation: any;
  questionNumber: string;
  submittedAnswer: string;
  uuid: string;
}

interface Props {
  answers: any;
  audioDecoderPlayer: AudioDecoderPlayer;
  body: any[];
  currentQuestionIndex: number;
  footer: any[];
  header: any[];
  totalQuestions: number;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "TypingQuestionReview",
  components: {
    AudioElement,
    ExerciseHtmlText,
    Separator
  },
  props: {
    answers: {
      type: Object,
      required: true
    },
    audioDecoderPlayer: {
      type: AudioDecoderPlayer,
      required: true
    },
    body: {
      type: Array,
      required: true
    },
    currentQuestionIndex: {
      type: Number,
      required: true
    },
    footer: {
      type: Array,
      required: true
    },
    header: {
      type: Array,
      required: true
    },
    totalQuestions: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      icons: {
        correct: IconCorrect,
        incorrect: IconIncorrect,
        skipped: IconSkipped
      }
    };
  },
  computed: {
    accuracyIcon() {
      if (this.explanation?.isCorrect) {
        return this.icons.correct;
      } else if (this.explanation?.isCorrect === false) {
        return this.icons.incorrect;
      } else {
        return this.icons.skipped;
      }
    },
    answerExplanation() {
      return this.body.find((component: any) => component.type === "TYPING_DRILL_ANSWER_EXPLANATION");
    },
    correctAnswer() {
      return this.explanation?.correctAnswer.text || "";
    },
    correctAnswerTranslation() {
      return this.explanation?.correctAnswer.translation || "";
    },
    explanation() {
      return this.answers[this.answerExplanation.problemUuid];
    },
    questionNumber() {
      if (this.currentQuestionIndex !== undefined) {
        return `Q${this.currentQuestionIndex + 1}`;
      } else {
        return this.header[0];
      }
    },
    submittedAnswer() {
      return this.explanation?.submittedAnswer || "";
    },
    uuid() {
      return this.answerExplanation.problemUuid;
    }
  },
  methods: {
    concatenatedBody(elementBody) {
      return concatenatedStringArray(elementBody);
    }
  }
});
